import type { LeasingRvOption } from "../types/calculatorData";

export interface CalculatorOptionWithStatus {
  Name: string;
  Value: number;
  Status: boolean;
  Price: number;
}

export interface CalcOptionsForContactUrl {
  LongTimeRentCalculatorValuesDTO: {
    Periods: CalculatorOptionWithStatus[];
    Ows: CalculatorOptionWithStatus[];
    Mileages: CalculatorOptionWithStatus[];
  };
  LeasingCalculatorValues: {
    Periods: CalculatorOptionWithStatus[];
    Ows: CalculatorOptionWithStatus[];
    Rvs: LeasingRvOption[];
  };
}

export interface PackageListEntry {
  isChecked: boolean;
  Value: number;
}

export type PackageListState = Record<string, PackageListEntry>;

export interface CalcOptionsRawForContactUrl {
  AuctionId: string;
  LeasingPeriods?: { Period: { Status: boolean } }[];
}

/**
 * Builds query string for contact form / modal (legacy Calculator.createURLToContactSection).
 * Example: AuctionId=…&FinancingMethod=2&Period=60&Ows=40&Rvs=20&Package6=false
 */
export function createURLToContactSection(
  calcOptions: CalcOptionsForContactUrl,
  calcOptionsRaw: CalcOptionsRawForContactUrl,
  packageList: PackageListState,
  selectedMethod: number,
  isAfterLease: boolean
): string {
  const paramObject: Record<string, string | number | boolean> = {
    AuctionId: calcOptionsRaw.AuctionId,
    FinancingMethod: selectedMethod,
    AfterLease: isAfterLease
  };

  const rent = calcOptions.LongTimeRentCalculatorValuesDTO;
  const leasing = calcOptions.LeasingCalculatorValues;

  if (selectedMethod === 1) {
    paramObject.Period = rent.Periods.find((x) => x.Status === true)!.Value;
    paramObject.Mileages = rent.Mileages.find((x) => x.Status === true)!.Value;
    paramObject.Ows = rent.Ows.find((x) => x.Status === true)!.Value;
  } else if (selectedMethod === 2) {
    paramObject.Rvs = leasing.Rvs.find((x) => x.Status === true)!.Value;
    paramObject.Period = leasing.Periods.find((x) => x.Status === true)!.Value;
    paramObject.Ows = leasing.Ows.find((x) => x.Status === true)!.Value;
  } else if (leasing.Periods.length) {
    paramObject.Rvs = leasing.Rvs.find((x) => x.Status === true)!.Value;
    paramObject.Period = leasing.Periods.find((x) => x.Status === true)!.Value;
    paramObject.Ows = leasing.Ows.find((x) => x.Status === true)!.Value;
  }

  if (selectedMethod !== 4) {
    for (const pkg of Object.keys(packageList)) {
      const obj = packageList[pkg];
      paramObject[`Package${obj.Value}`] = obj.isChecked;
    }
  }

  return new URLSearchParams(
    Object.entries(paramObject).map(([key, value]) => [key, String(value)])
  ).toString();
}
